// Checks if value is JS number type
export const isNumber = (value: unknown): value is number =>
  typeof value === 'number' && isFinite(value);
